export const userProfileDivStyle = {
  padding: '0 220px',
  width: 'auto',
}

export const titleContainerStyle = {
  display: 'flex',
  flexDirection: 'initial',
  alignItems: 'center',
  width: '100%',
  borderBottom: '1px solid #c1bbb3',
  marginTop: '15px',
  height: '60px',
  paddingBottom: '20px',
  gap: '24px',
  marginLeft: '24px',
  paddingLeft: '0px !important'
}

export const infoContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  borderBottom: '1px solid #c1bbb3',
  marginTop: '15px',
  height: '50px',
  marginLeft: '24px',
}

export const editButtonStyle = {
  borderRadius: '9999px',
  color: '#000',
  backgroundColor: '#F1EFED',
}

export const infoTitleStyle = {
  fontFamily: 'JohnsonText, Arial, sans-serif',
  fontWeight: 'bold',
  width: '50%',
  whiteSpace: 'nowrap',
  paddingRight: '50%'
}

export const infoTextStyle = {
  fontFamily: 'JohnsonText, Arial, sans-serif',
  whiteSpace: 'normal',
}

export const superAdminCapsule = {
  height: '24px',
  width: '96px',
  backgroundColor: '#69D0FF40',
  fontSize: '12px',
  fontWeight: 'bold',
  borderRadius: '9999px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

// Mobile

export const userProfileDivStyleMobile = {
  padding: '0 20px',
  // width: '100vw'
}

export const infoContainerStyleMobile = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  marginTop: '15px',
  height: '50px',
  gap: '15px',
  paddingLeft: '0px !important',
}

export const infoTextStyleMobile = {
  fontFamily: 'JohnsonText, Arial, sans-serif',
  paddingRight: '17%',
  whiteSpace: 'nowrap'
}

export const infoTextStyleEmailMobile = {
  fontFamily: 'JohnsonText, Arial, sans-serif',
  paddingRight: '17%',
  whiteSpace: 'nowrap',
  '@media (max-width:500px)': {
    pl: '7px',
  },
}

export const infoTextEmailStyle = {
  fontFamily: 'JohnsonText, Arial, sans-serif',
  whiteSpace: 'normal',
  '@media (max-width:500px)': {
    pl: '7px',
  },
  '@media (min-width:765px) and (max-width:945px)': {
    pl: '7px',
  },
}
